import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getTaxZones } from "../../api/apiTax";

export const useGetTaxZones = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["tax-zones", params, i18next.language],
        queryFn: () => getTaxZones(params),
        keepPreviousData: true,
    });

    const zones = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params?.per_page || 15, total: 0 };

    return { isLoading, error, zones, meta, refetch };
};
